// https://www.chartjs.org/docs/latest/getting-started/integration.html#bundle-optimization
// https://www.chartjs.org/docs/latest/getting-started/usage.html#tree-shaking
import {
	BarController,
	BarElement,
	CategoryScale,
	Chart,
	Colors,
	Legend,
	LinearScale,
	LineController,
	LineElement,
	PointElement,
	Tooltip,
} from "chart.js"
import {
	ChoroplethController,
	ColorScale,
	GeoFeature,
	ProjectionScale,
} from "chartjs-chart-geo"

Chart.register(
	Colors,
	LineController,
	LineElement,
	PointElement,
	CategoryScale,
	LinearScale,
	Legend,
	Tooltip,
	BarController,
	BarElement,
	ChoroplethController,
	GeoFeature,
	ColorScale,
	ProjectionScale,
)
